import type { PhoneNumber } from "libphonenumber-js/max";

export interface Place {
  // Where the range was issued, which is as fine as a suburb in some plans and as coarse as a state in others.
  location: string;
  // The operator the range was given to, and never the one holding it now: a ported number still reads as its first.
  network: string;
  zones: string[];
}

export const NOWHERE: Place = { location: "", network: "", zones: [] };

// The maps `bun run phone-geo` writes, named through a glob rather than one import each so that adding a calling code
// upstream needs no edit here. `?url` is what keeps 7.6 MB out of this chunk: each is emitted as an asset of its own,
// hashed by the build like every other, and read only if somebody types a number in that country.
const MAPS = { "./maps/1.json": __glob_0, "./maps/20.json": __glob_1, "./maps/211.json": __glob_2, "./maps/212.json": __glob_3, "./maps/213.json": __glob_4, "./maps/216.json": __glob_5, "./maps/218.json": __glob_6, "./maps/220.json": __glob_7, "./maps/221.json": __glob_8, "./maps/222.json": __glob_9, "./maps/223.json": __glob_10, "./maps/224.json": __glob_11, "./maps/225.json": __glob_12, "./maps/226.json": __glob_13, "./maps/227.json": __glob_14, "./maps/228.json": __glob_15, "./maps/229.json": __glob_16, "./maps/230.json": __glob_17, "./maps/231.json": __glob_18, "./maps/232.json": __glob_19, "./maps/233.json": __glob_20, "./maps/234.json": __glob_21, "./maps/235.json": __glob_22, "./maps/236.json": __glob_23, "./maps/237.json": __glob_24, "./maps/238.json": __glob_25, "./maps/239.json": __glob_26, "./maps/240.json": __glob_27, "./maps/241.json": __glob_28, "./maps/242.json": __glob_29, "./maps/243.json": __glob_30, "./maps/244.json": __glob_31, "./maps/245.json": __glob_32, "./maps/246.json": __glob_33, "./maps/247.json": __glob_34, "./maps/248.json": __glob_35, "./maps/249.json": __glob_36, "./maps/250.json": __glob_37, "./maps/251.json": __glob_38, "./maps/252.json": __glob_39, "./maps/253.json": __glob_40, "./maps/254.json": __glob_41, "./maps/255.json": __glob_42, "./maps/256.json": __glob_43, "./maps/257.json": __glob_44, "./maps/258.json": __glob_45, "./maps/260.json": __glob_46, "./maps/261.json": __glob_47, "./maps/262.json": __glob_48, "./maps/263.json": __glob_49, "./maps/264.json": __glob_50, "./maps/265.json": __glob_51, "./maps/266.json": __glob_52, "./maps/267.json": __glob_53, "./maps/268.json": __glob_54, "./maps/269.json": __glob_55, "./maps/27.json": __glob_56, "./maps/290.json": __glob_57, "./maps/291.json": __glob_58, "./maps/297.json": __glob_59, "./maps/298.json": __glob_60, "./maps/299.json": __glob_61, "./maps/30.json": __glob_62, "./maps/31.json": __glob_63, "./maps/32.json": __glob_64, "./maps/33.json": __glob_65, "./maps/34.json": __glob_66, "./maps/350.json": __glob_67, "./maps/351.json": __glob_68, "./maps/352.json": __glob_69, "./maps/353.json": __glob_70, "./maps/354.json": __glob_71, "./maps/355.json": __glob_72, "./maps/356.json": __glob_73, "./maps/357.json": __glob_74, "./maps/358.json": __glob_75, "./maps/359.json": __glob_76, "./maps/36.json": __glob_77, "./maps/370.json": __glob_78, "./maps/371.json": __glob_79, "./maps/372.json": __glob_80, "./maps/373.json": __glob_81, "./maps/374.json": __glob_82, "./maps/375.json": __glob_83, "./maps/376.json": __glob_84, "./maps/377.json": __glob_85, "./maps/378.json": __glob_86, "./maps/380.json": __glob_87, "./maps/381.json": __glob_88, "./maps/382.json": __glob_89, "./maps/383.json": __glob_90, "./maps/385.json": __glob_91, "./maps/386.json": __glob_92, "./maps/387.json": __glob_93, "./maps/389.json": __glob_94, "./maps/39.json": __glob_95, "./maps/40.json": __glob_96, "./maps/41.json": __glob_97, "./maps/420.json": __glob_98, "./maps/421.json": __glob_99, "./maps/423.json": __glob_100, "./maps/43.json": __glob_101, "./maps/44.json": __glob_102, "./maps/45.json": __glob_103, "./maps/46.json": __glob_104, "./maps/47.json": __glob_105, "./maps/48.json": __glob_106, "./maps/49.json": __glob_107, "./maps/500.json": __glob_108, "./maps/501.json": __glob_109, "./maps/502.json": __glob_110, "./maps/503.json": __glob_111, "./maps/504.json": __glob_112, "./maps/505.json": __glob_113, "./maps/506.json": __glob_114, "./maps/507.json": __glob_115, "./maps/508.json": __glob_116, "./maps/509.json": __glob_117, "./maps/51.json": __glob_118, "./maps/52.json": __glob_119, "./maps/53.json": __glob_120, "./maps/54.json": __glob_121, "./maps/55.json": __glob_122, "./maps/56.json": __glob_123, "./maps/57.json": __glob_124, "./maps/58.json": __glob_125, "./maps/590.json": __glob_126, "./maps/591.json": __glob_127, "./maps/592.json": __glob_128, "./maps/593.json": __glob_129, "./maps/594.json": __glob_130, "./maps/595.json": __glob_131, "./maps/596.json": __glob_132, "./maps/597.json": __glob_133, "./maps/598.json": __glob_134, "./maps/599.json": __glob_135, "./maps/60.json": __glob_136, "./maps/61.json": __glob_137, "./maps/62.json": __glob_138, "./maps/63.json": __glob_139, "./maps/64.json": __glob_140, "./maps/65.json": __glob_141, "./maps/66.json": __glob_142, "./maps/670.json": __glob_143, "./maps/672.json": __glob_144, "./maps/673.json": __glob_145, "./maps/674.json": __glob_146, "./maps/675.json": __glob_147, "./maps/676.json": __glob_148, "./maps/677.json": __glob_149, "./maps/678.json": __glob_150, "./maps/679.json": __glob_151, "./maps/680.json": __glob_152, "./maps/681.json": __glob_153, "./maps/682.json": __glob_154, "./maps/683.json": __glob_155, "./maps/685.json": __glob_156, "./maps/686.json": __glob_157, "./maps/687.json": __glob_158, "./maps/688.json": __glob_159, "./maps/689.json": __glob_160, "./maps/690.json": __glob_161, "./maps/691.json": __glob_162, "./maps/692.json": __glob_163, "./maps/7.json": __glob_164, "./maps/81.json": __glob_165, "./maps/82.json": __glob_166, "./maps/84.json": __glob_167, "./maps/850.json": __glob_168, "./maps/852.json": __glob_169, "./maps/853.json": __glob_170, "./maps/855.json": __glob_171, "./maps/856.json": __glob_172, "./maps/86.json": __glob_173, "./maps/880.json": __glob_174, "./maps/881.json": __glob_175, "./maps/882.json": __glob_176, "./maps/886.json": __glob_177, "./maps/90.json": __glob_178, "./maps/91.json": __glob_179, "./maps/92.json": __glob_180, "./maps/93.json": __glob_181, "./maps/94.json": __glob_182, "./maps/95.json": __glob_183, "./maps/960.json": __glob_184, "./maps/961.json": __glob_185, "./maps/962.json": __glob_186, "./maps/963.json": __glob_187, "./maps/964.json": __glob_188, "./maps/965.json": __glob_189, "./maps/966.json": __glob_190, "./maps/967.json": __glob_191, "./maps/968.json": __glob_192, "./maps/970.json": __glob_193, "./maps/971.json": __glob_194, "./maps/972.json": __glob_195, "./maps/973.json": __glob_196, "./maps/974.json": __glob_197, "./maps/975.json": __glob_198, "./maps/976.json": __glob_199, "./maps/977.json": __glob_200, "./maps/98.json": __glob_201, "./maps/992.json": __glob_202, "./maps/993.json": __glob_203, "./maps/994.json": __glob_204, "./maps/995.json": __glob_205, "./maps/996.json": __glob_206, "./maps/998.json": __glob_207, "./maps/zones.json": __glob_208 } as Record<
  string,
  string
>;

// The three maps Google publishes beside the numbering plans, asked together and kept by the number they were asked
// about, so that a page re-rendering under somebody's typing is not a page asking the same question over again.
export function place(number: PhoneNumber): Promise<Place> {
  const held = places.get(number.number);
  if (held) return held;

  const asked = read(number);
  // A lookup the network dropped is worth making again, so only an answer is kept.
  asked.catch(() => places.delete(number.number));
  places.set(number.number, asked);
  return asked;
}

const places = new Map<string, Promise<Place>>();

async function read(number: PhoneNumber): Promise<Place> {
  const [maps, zones] = await Promise.all([load<Maps>(number.countryCallingCode), load<Zones>("zones")]);
  // All three are keyed the way Google writes them down, which is the number as it is dialled from abroad: the map
  // for one calling code repeats it on every prefix, and the map of zones covers them all and has to.
  const dialled = `${number.countryCallingCode}${number.nationalNumber}`;

  return {
    location: longest(maps?.geo, dialled) ?? "",
    network: longest(maps?.carrier, dialled) ?? "",
    zones: longest(zones, dialled) ?? [],
  };
}

interface Maps {
  geo: Record<string, string>;
  carrier: Record<string, string>;
}

type Zones = Record<string, string[]>;

// A plan is written down as the shortest prefix that answers for everything below it, so the answer for a number is
// the longest of its prefixes the map has anything at all against — down to the calling code itself, which is what
// answers for the forty zones +1 reaches and for a country that maps its whole plan to one place.
function longest<T>(prefixes: Record<string, T> | undefined, digits: string): T | undefined {
  if (!prefixes) return undefined;
  for (let length = digits.length; length > 0; length--) {
    const found = prefixes[digits.slice(0, length)];
    if (found !== undefined) return found;
  }
  return undefined;
}

const files = new Map<string, Promise<unknown>>();

// A calling code nothing is known about has no file to ask for, which the glob says without a request being made.
function load<T>(name: string): Promise<T | undefined> {
  const url = MAPS[`./maps/${name}.json`];
  if (!url) return Promise.resolve(undefined);

  const held = files.get(url);
  if (held) return held as Promise<T>;

  const file = fetch(url).then((response) => {
    if (!response.ok) throw new Error(`${url}: ${response.status}`);
    return response.json() as Promise<T>;
  });
  file.catch(() => files.delete(url));
  files.set(url, file);
  return file;
}

// The zone with the clock it keeps, which is the half of a zone name that answers whether this is an hour to ring at.
// The words are the browser's own, so "GMT+11" is spelled however this reader's Intl spells it.
export function zoneWithOffset(zone: string): string {
  try {
    const parts = new Intl.DateTimeFormat("en", { timeZone: zone, timeZoneName: "shortOffset" }).formatToParts();
    const offset = parts.find((part) => part.type === "timeZoneName")?.value;
    return offset ? `${zone} (${offset})` : zone;
  } catch {
    // A zone this browser's Intl has never heard of is still a zone name worth showing.
    return zone;
  }
}

import __glob_0 from "./maps/1.json?url";
import __glob_1 from "./maps/20.json?url";
import __glob_2 from "./maps/211.json?url";
import __glob_3 from "./maps/212.json?url";
import __glob_4 from "./maps/213.json?url";
import __glob_5 from "./maps/216.json?url";
import __glob_6 from "./maps/218.json?url";
import __glob_7 from "./maps/220.json?url";
import __glob_8 from "./maps/221.json?url";
import __glob_9 from "./maps/222.json?url";
import __glob_10 from "./maps/223.json?url";
import __glob_11 from "./maps/224.json?url";
import __glob_12 from "./maps/225.json?url";
import __glob_13 from "./maps/226.json?url";
import __glob_14 from "./maps/227.json?url";
import __glob_15 from "./maps/228.json?url";
import __glob_16 from "./maps/229.json?url";
import __glob_17 from "./maps/230.json?url";
import __glob_18 from "./maps/231.json?url";
import __glob_19 from "./maps/232.json?url";
import __glob_20 from "./maps/233.json?url";
import __glob_21 from "./maps/234.json?url";
import __glob_22 from "./maps/235.json?url";
import __glob_23 from "./maps/236.json?url";
import __glob_24 from "./maps/237.json?url";
import __glob_25 from "./maps/238.json?url";
import __glob_26 from "./maps/239.json?url";
import __glob_27 from "./maps/240.json?url";
import __glob_28 from "./maps/241.json?url";
import __glob_29 from "./maps/242.json?url";
import __glob_30 from "./maps/243.json?url";
import __glob_31 from "./maps/244.json?url";
import __glob_32 from "./maps/245.json?url";
import __glob_33 from "./maps/246.json?url";
import __glob_34 from "./maps/247.json?url";
import __glob_35 from "./maps/248.json?url";
import __glob_36 from "./maps/249.json?url";
import __glob_37 from "./maps/250.json?url";
import __glob_38 from "./maps/251.json?url";
import __glob_39 from "./maps/252.json?url";
import __glob_40 from "./maps/253.json?url";
import __glob_41 from "./maps/254.json?url";
import __glob_42 from "./maps/255.json?url";
import __glob_43 from "./maps/256.json?url";
import __glob_44 from "./maps/257.json?url";
import __glob_45 from "./maps/258.json?url";
import __glob_46 from "./maps/260.json?url";
import __glob_47 from "./maps/261.json?url";
import __glob_48 from "./maps/262.json?url";
import __glob_49 from "./maps/263.json?url";
import __glob_50 from "./maps/264.json?url";
import __glob_51 from "./maps/265.json?url";
import __glob_52 from "./maps/266.json?url";
import __glob_53 from "./maps/267.json?url";
import __glob_54 from "./maps/268.json?url";
import __glob_55 from "./maps/269.json?url";
import __glob_56 from "./maps/27.json?url";
import __glob_57 from "./maps/290.json?url";
import __glob_58 from "./maps/291.json?url";
import __glob_59 from "./maps/297.json?url";
import __glob_60 from "./maps/298.json?url";
import __glob_61 from "./maps/299.json?url";
import __glob_62 from "./maps/30.json?url";
import __glob_63 from "./maps/31.json?url";
import __glob_64 from "./maps/32.json?url";
import __glob_65 from "./maps/33.json?url";
import __glob_66 from "./maps/34.json?url";
import __glob_67 from "./maps/350.json?url";
import __glob_68 from "./maps/351.json?url";
import __glob_69 from "./maps/352.json?url";
import __glob_70 from "./maps/353.json?url";
import __glob_71 from "./maps/354.json?url";
import __glob_72 from "./maps/355.json?url";
import __glob_73 from "./maps/356.json?url";
import __glob_74 from "./maps/357.json?url";
import __glob_75 from "./maps/358.json?url";
import __glob_76 from "./maps/359.json?url";
import __glob_77 from "./maps/36.json?url";
import __glob_78 from "./maps/370.json?url";
import __glob_79 from "./maps/371.json?url";
import __glob_80 from "./maps/372.json?url";
import __glob_81 from "./maps/373.json?url";
import __glob_82 from "./maps/374.json?url";
import __glob_83 from "./maps/375.json?url";
import __glob_84 from "./maps/376.json?url";
import __glob_85 from "./maps/377.json?url";
import __glob_86 from "./maps/378.json?url";
import __glob_87 from "./maps/380.json?url";
import __glob_88 from "./maps/381.json?url";
import __glob_89 from "./maps/382.json?url";
import __glob_90 from "./maps/383.json?url";
import __glob_91 from "./maps/385.json?url";
import __glob_92 from "./maps/386.json?url";
import __glob_93 from "./maps/387.json?url";
import __glob_94 from "./maps/389.json?url";
import __glob_95 from "./maps/39.json?url";
import __glob_96 from "./maps/40.json?url";
import __glob_97 from "./maps/41.json?url";
import __glob_98 from "./maps/420.json?url";
import __glob_99 from "./maps/421.json?url";
import __glob_100 from "./maps/423.json?url";
import __glob_101 from "./maps/43.json?url";
import __glob_102 from "./maps/44.json?url";
import __glob_103 from "./maps/45.json?url";
import __glob_104 from "./maps/46.json?url";
import __glob_105 from "./maps/47.json?url";
import __glob_106 from "./maps/48.json?url";
import __glob_107 from "./maps/49.json?url";
import __glob_108 from "./maps/500.json?url";
import __glob_109 from "./maps/501.json?url";
import __glob_110 from "./maps/502.json?url";
import __glob_111 from "./maps/503.json?url";
import __glob_112 from "./maps/504.json?url";
import __glob_113 from "./maps/505.json?url";
import __glob_114 from "./maps/506.json?url";
import __glob_115 from "./maps/507.json?url";
import __glob_116 from "./maps/508.json?url";
import __glob_117 from "./maps/509.json?url";
import __glob_118 from "./maps/51.json?url";
import __glob_119 from "./maps/52.json?url";
import __glob_120 from "./maps/53.json?url";
import __glob_121 from "./maps/54.json?url";
import __glob_122 from "./maps/55.json?url";
import __glob_123 from "./maps/56.json?url";
import __glob_124 from "./maps/57.json?url";
import __glob_125 from "./maps/58.json?url";
import __glob_126 from "./maps/590.json?url";
import __glob_127 from "./maps/591.json?url";
import __glob_128 from "./maps/592.json?url";
import __glob_129 from "./maps/593.json?url";
import __glob_130 from "./maps/594.json?url";
import __glob_131 from "./maps/595.json?url";
import __glob_132 from "./maps/596.json?url";
import __glob_133 from "./maps/597.json?url";
import __glob_134 from "./maps/598.json?url";
import __glob_135 from "./maps/599.json?url";
import __glob_136 from "./maps/60.json?url";
import __glob_137 from "./maps/61.json?url";
import __glob_138 from "./maps/62.json?url";
import __glob_139 from "./maps/63.json?url";
import __glob_140 from "./maps/64.json?url";
import __glob_141 from "./maps/65.json?url";
import __glob_142 from "./maps/66.json?url";
import __glob_143 from "./maps/670.json?url";
import __glob_144 from "./maps/672.json?url";
import __glob_145 from "./maps/673.json?url";
import __glob_146 from "./maps/674.json?url";
import __glob_147 from "./maps/675.json?url";
import __glob_148 from "./maps/676.json?url";
import __glob_149 from "./maps/677.json?url";
import __glob_150 from "./maps/678.json?url";
import __glob_151 from "./maps/679.json?url";
import __glob_152 from "./maps/680.json?url";
import __glob_153 from "./maps/681.json?url";
import __glob_154 from "./maps/682.json?url";
import __glob_155 from "./maps/683.json?url";
import __glob_156 from "./maps/685.json?url";
import __glob_157 from "./maps/686.json?url";
import __glob_158 from "./maps/687.json?url";
import __glob_159 from "./maps/688.json?url";
import __glob_160 from "./maps/689.json?url";
import __glob_161 from "./maps/690.json?url";
import __glob_162 from "./maps/691.json?url";
import __glob_163 from "./maps/692.json?url";
import __glob_164 from "./maps/7.json?url";
import __glob_165 from "./maps/81.json?url";
import __glob_166 from "./maps/82.json?url";
import __glob_167 from "./maps/84.json?url";
import __glob_168 from "./maps/850.json?url";
import __glob_169 from "./maps/852.json?url";
import __glob_170 from "./maps/853.json?url";
import __glob_171 from "./maps/855.json?url";
import __glob_172 from "./maps/856.json?url";
import __glob_173 from "./maps/86.json?url";
import __glob_174 from "./maps/880.json?url";
import __glob_175 from "./maps/881.json?url";
import __glob_176 from "./maps/882.json?url";
import __glob_177 from "./maps/886.json?url";
import __glob_178 from "./maps/90.json?url";
import __glob_179 from "./maps/91.json?url";
import __glob_180 from "./maps/92.json?url";
import __glob_181 from "./maps/93.json?url";
import __glob_182 from "./maps/94.json?url";
import __glob_183 from "./maps/95.json?url";
import __glob_184 from "./maps/960.json?url";
import __glob_185 from "./maps/961.json?url";
import __glob_186 from "./maps/962.json?url";
import __glob_187 from "./maps/963.json?url";
import __glob_188 from "./maps/964.json?url";
import __glob_189 from "./maps/965.json?url";
import __glob_190 from "./maps/966.json?url";
import __glob_191 from "./maps/967.json?url";
import __glob_192 from "./maps/968.json?url";
import __glob_193 from "./maps/970.json?url";
import __glob_194 from "./maps/971.json?url";
import __glob_195 from "./maps/972.json?url";
import __glob_196 from "./maps/973.json?url";
import __glob_197 from "./maps/974.json?url";
import __glob_198 from "./maps/975.json?url";
import __glob_199 from "./maps/976.json?url";
import __glob_200 from "./maps/977.json?url";
import __glob_201 from "./maps/98.json?url";
import __glob_202 from "./maps/992.json?url";
import __glob_203 from "./maps/993.json?url";
import __glob_204 from "./maps/994.json?url";
import __glob_205 from "./maps/995.json?url";
import __glob_206 from "./maps/996.json?url";
import __glob_207 from "./maps/998.json?url";
import __glob_208 from "./maps/zones.json?url";
